import httpClient from './httpClient'

export default {
  Audit: {
    SendAudit(payload) {
      return httpClient.post('Audit/Create', payload)
    },
  },
}
